import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  InputGroupAddon,
  DropdownItem,
  DropdownMenu,
  ButtonDropdown,
  Card,
  CardBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { localeOptions } from '../../../../../../constants/defaultValues';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import CodeSnippet from './CodeSinppet';
import Select from 'react-select';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
export default function Addons({
  saveIntegration,
  channelDetails,
  propertyId,
  integrationId,
  serviceProvider,
  allProperties,
}) {
  const [emailList, setEmailList] = useState(
    channelDetails?.addOn?.emails || []
  );
  useEffect(() => {
    if (
      channelDetails?.addOn?.emails &&
      channelDetails?.addOn?.emails.length > 0
    ) {
      let lst = [];
      channelDetails.addOn.emails.map((m) => {
        let propList = [];
        if (m?.properties) {
          propList = m?.properties.map((p) => {
            if (allProperties.filter((f) => f.id === p).length > 0) {
              let obj = allProperties.filter((f) => f.id === p)[0];
              return { key: obj.id, value: obj.id, label: obj.name };
            }
          });
        }
        console.log(propList,'propList');
        lst.push({ email: m.email, properties: propList });
      });

      setPropertyEmails(lst);
    }
  }, [propertyId]);

  const [propertyEmails, setPropertyEmails] = useState([]);
  const handleSave = (e) => {
    var details = { ...channelDetails };
    details.addOn.emails = emailList;
    saveIntegration({ channelDetails: details });
  };

  const handleAddEmails = () => {
    let lst = [...emailList];
    lst.push({
      email: '',
      language: 'en',
    });
    setEmailList(lst);
  };

  const handlRemove = (e) =>
    setEmailList(emailList.filter((f, index) => index !== e));

  const handleChange = (e, index, name) => {
    let lst = [...emailList];
    lst[index][name] = e.target.value;
    setEmailList(lst);
  };

  const handleSelectChange = (val, index) => {
    console.log(val, index);
    let lst = [...propertyEmails];
    lst[index].properties = val;
    let emaillst = [...emailList];
    emaillst[index].properties = val.map(m=>m.value);
    setPropertyEmails(lst);
    setEmailList(emaillst);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Microsoft Outlook Add-on</h6>
            <span>Generate AI reply to emails without leaving outlook</span>
          </div>
          <Separator className="mb-3" />
          <div className="text-left mb-2">
            <h6>Authorized Email Addresses</h6>
            <p className="my-2 mb-3">
              List email addresses that are allowed to connect from Outlook
            </p>
          </div>
          {emailList.map((m, index) => (
            <div className="row mt-1  mb-2">
              <div className="col-md-5">
                <Select
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  isMulti={true}
                  classNamePrefix="react-select"
                  name="form-field-name"
                  options={allProperties.map((x, i) => {
                    return {
                      label: x.name,
                      value: x.id,
                      key: i,
                    };
                  })}
                  value={
                    propertyEmails.filter((f) => f.email === m.email)[0]
                      ?.properties ?? []
                  }
                  onChange={(val) => handleSelectChange(val, index)}
                />
              </div>
              <div className="col-md-6">
                <InputGroup>
                  <Input
                    value={m?.email}
                    type="text"
                    onChange={(e) => handleChange(e, index, 'email')}
                  ></Input>
                  <InputGroupAddon addonType="append">
                    <Input
                      type="select"
                      value={m?.language}
                      onChange={(e) => handleChange(e, index, 'language')}
                    >
                      <option value="">Please select</option>
                      {localeOptions.map((elem) => (
                        <option value={elem.id}>{elem.name}</option>
                      ))}
                    </Input>
                  </InputGroupAddon>
                </InputGroup>
              </div>
              <div className="col-md-1 mt-1">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handlRemove(index)}
                >
                  -
                </Button>
              </div>
            </div>
          ))}
          <div className="row mt-1 ml-2 mb-3">
            <div className="d-flex w-100">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={handleAddEmails}
              >
                + Add Email
              </Button>
            </div>
          </div>
          <Row>
            <CodeSnippet
              propertyId={propertyId}
              allProperties={allProperties}
              integrationId={integrationId}
              serviceProvider={serviceProvider}
            ></CodeSnippet>
          </Row>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button onClick={() => handleSave()} color="primary" size="xs">
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
